import { TextAreaWUT } from '@wix/form-fields/wut';

export default TextAreaWUT;
